import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import PromotionForm from './PromotionForm';

const PromotionActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const PromotionEdit = (props: any) => {
  return (
    <Edit actions={<PromotionActions {...props} />} {...props}>
      <PromotionForm />
    </Edit>
  );
};

export default PromotionEdit;
